export default __webpack_public_path__ + "static/media/process-bg.407d5901.png";